import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { MethodOverview } from './components/MethodOverview';
import { MaterialPreview } from './components/MaterialPreview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { WhatsAppButton } from './components/WhatsAppButton';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-12 md:py-20 text-center pt-[4px] pb-[4px]" data-id="element-0" data-mp="28te3lff7pdo5">
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed font-[800]" data-id="element-1" data-mp="23w4ey1znd61d">
      🌱 La próxima consulta puede ser diferente.
    </p>
  </div>;
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="leaf-canvas min-h-screen text-brand-text font-sans selection:bg-brand-greenLight/40 selection:text-brand-purpleDark" data-id="element-2" data-mp="3mj6jhwnqi0fz">
      <UrgencyBanner data-id="element-3" data-mp="680frswe88f" />
      <Hero data-id="element-4" data-mp="5gel8p3rovc" />
      <InitialTestimonials data-id="element-5" data-mp="56l3b4umzkw" />
      <PainPoints data-id="element-6" data-mp="2zl3c5m4yv85u" />
      <MethodOverview data-id="element-7" data-mp="2zlld2w2kqak3" />
      <MaterialPreview data-id="element-8" data-mp="2zmeowbge3q93" />
      <MoreTestimonials data-id="element-9" data-mp="2zmwlj96ys6hj" />
      <Guarantee data-id="element-10" data-mp="33movnqc0akp0" />
      <FAQ data-id="element-11" data-mp="33m5ck6amdq9e" />
      <CostComparison data-id="element-12" data-mp="33lx18iu5at0b" />
      <TransitionPhrase data-id="element-13" data-mp="33n6y54p9hv5d" />
      <EmotionalClose data-id="element-14" data-mp="33oi3h8ycvayl" />
      <Footer data-id="element-15" data-mp="38m1fe27kzbnd" />
      <FloatingNotification data-id="element-16" data-mp="38li8dgjgy7o4" />
      <WhatsAppButton data-id="element-17" data-mp="38k6v8q44vnkc" />
    </div>;
}